// import Link from 'next/link';
import React from 'react'
import {ChevronLeftIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";

const ShowTabsList = ({tabsList, selectedTab, setSelectedTab}) => {

    return (
        <>
            <div className="flex flex-wrap justify-start items-start border-b border-gray-500 px-8">
                {tabsList?.map((tabItem, index) => (
                    <div key={index} className="mx-1">
                        <button
                            onClick={() => {
                                setSelectedTab(tabItem)
                            }}
                            className={`show-tab ${tabItem?.key === selectedTab?.key ? 'show-tab-selected' : ''}`}>
                            <div className="mx-2">{tabItem?.label}</div>
                        </button>
                    </div>
                ))}
            </div>

        </>
    )
}

export default ShowTabsList
